module.exports = __webpack_public_path__ + "static/surf-destinations-light-dd966c58cea5574acc1bc0cc8f30354a.mp4";